import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseOptionAPI } from '@core/_base/crud/models/_base.option-api';
import { TypesUtilsService, ResponseBody } from '@core/_base/crud';
import { environment } from '@env/environment.prod';
import { tap } from 'rxjs/operators';
import { Device } from '../_models/device';
import { DeviceGroup } from '../_models/device-group';
import { Driver } from '../_models/driver';
import { Camera } from '../_models/camera';

const API_URL: string = environment.api.host + '/settings/cameras';
const API_FLV_URL: string =
	'http://www.evbig.com:20710/api/v1/basic/live/video';


export interface ListTimePlayBackParam {
	deviceId: number,
	timeStart: string,
	timeEnd: string,
	cameraIds: string,
}	
@Injectable({
	providedIn: 'root',
})
export class CameraService {
	constructor(private http: HttpClient, private utils: TypesUtilsService) {}
	list(option?: BaseOptionAPI): Observable<ResponseBody> {
		return this.http.get<ResponseBody>(API_URL, {
			params: this.utils.processBassOptionApi(option),
		});
	}

	listUrlStream(option?: BaseOptionAPI): Observable<ResponseBody> {
		return this.http.get<ResponseBody>(API_URL + '/stream', {
			params: this.utils.processBassOptionApi(option),
		});
	}

	listTimePlayback(params?: any): Observable<ResponseBody> {
		return this.http.get<ResponseBody>(API_URL + '/time-playback', {
			params:params
		});
	}

	listCalendarPlayback(params?: any): Observable<ResponseBody> {
		return this.http.get<ResponseBody>(API_URL + '/calendar-playback', {
			params: params
		});
	}

	listUrlPlayback(option?: BaseOptionAPI): Observable<ResponseBody> {
		return this.http.get<ResponseBody>(API_URL + '/playback', {
			params: this.utils.processBassOptionApi(option),
		});
	}

	detail(id: number, option?: BaseOptionAPI): Observable<ResponseBody> {
		return this.http
			.get<ResponseBody>(API_URL + '/search', {
				params: this.utils.processBassOptionApi(option),
			})
			.pipe(
				tap((body) => {
					if (body.result.content) {
						body.result.content = body.result.content.map(function (
							x
						) {
							let tranfrom = new Device().deserialize(x, {
								tranform: {
									id: 'id',
									name: 'name',
									description: 'description',
									updatedBy: '',
									updatedDate: 'createdAt',
									createdBy: '',
									createdDate: 'createdAt',
									sortOrder: '',
								},
							});
							return tranfrom;
						});

						body.result = body.result.content.find(
							(x) => x.id == id
						);
					}
				})
			);
	}

	create(camera: Camera, option?: BaseOptionAPI): Observable<ResponseBody> {
		const formData = new FormData();
		formData.append('name', camera.name);
		formData.append('deviceId', camera.deviceId.toString());
		formData.append('cameraId', camera.cameraId);
		formData.append('description', camera.description);

		return this.http.post<ResponseBody>(API_URL, formData, {
			params: this.utils.processBassOptionApi(option),
		});
	}

	update(camera: Camera, option?: BaseOptionAPI): Observable<ResponseBody> {
		const formData = new FormData();
		formData.append('name', camera.name);
		formData.append('deviceId', camera.deviceId.toString());
		formData.append('cameraId', camera.cameraId);
		formData.append('description', camera.description);

		return this.http.put<ResponseBody>(
			API_URL + '/' + camera.id,
			formData,
			{
				params: this.utils.processBassOptionApi(option),
			}
		);
	}

	delete(id: number, option?: BaseOptionAPI): Observable<ResponseBody> {
		const url = `${API_URL}/${id}`;
		return this.http.delete<ResponseBody>(url, {
			params: this.utils.processBassOptionApi(option),
		});
	}
}
